/*
 * @Author: chenguanghua
 * @Date: 2022-07-025 16:58:32
 * @LastEditors: zry
 * @LastEditTime: 2025-09-16 17:58:25
 * @Description: 维保报告信息
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const bgglService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfwb/wbbg`, { params: params }); },

  // 查看
  getDetail: (id) => { return axios.get(`${iffApi}/xfwb/wbbg/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfwb/wbbg/export`, { responseType: 'blob', params }); },

  // 报告推送信息获取
  getWbbgSjts: (params) => { return axios.get(`${iffApi}/xfwb/wbbg/sjts`, { params: params }); },

  getWbbgCommon: (params) => { return axios.get(`${iffApi}/noauth/common/wbbg/page`, { params: params }); },

  // 报告导入
  importBg: (fd) => { return axios.post(`${iffApi}/xfwb/wbbg/import`, fd); },

  // 全国系统数据推送
  qgxtSjts: (xmId, bgId) => { return axios.post(`${iffApi}/xfwb/wbbg/common/sjts/qgxt/${xmId}/${bgId}`); },

  // 广东社会平台数据推送
  gdshptSjts: (xmId, bgId) => { return axios.post(`${iffApi}/xfwb/wbbg/upload/gdshpt/${xmId}/${bgId}`); },

  // 获取广东社会平台数据推送结果
  getGdshptResult: (bgId) => { return axios.get(`${iffApi}/xfwb/wbbg/query/gdshpt/${bgId}/result`); },

  // 联网单位平台数据推送
  lwdwptSjts: (id) => { return axios.get(`${iffApi}/common/sjts/lwdwpt/${id}`); },

  // 获取联网单位
  lwdwptLsdws: (bgId) => { return axios.get(`${iffApi}/common/get/lwdwpt/lwdw/${bgId}`); },

  lwdwptSjTb: (fd) => { return axios.post(`${iffApi}/common/sjtb/lwdwpt/`, fd); },

  // 获取跳转打印标签信息
  getDybqInfo: (id) => { return axios.get(`${iffApi}/wbbg/dybqXq/${id}`); },

  // 打印标签
  dybq: (id) => { return axios.get(`${iffApi}/wbbg/dybq/${id}`); },

  // 申请修改报告
  sqxg: (params) => { return axios.post(`${iffApi}/xfwb/wbjh/wbbg/sqxg`, params); },

  // 下载标签
  xzbq: (id) => { return axios.get(`${iffApi}/wbbg/xzbq/${id}`); },

  // 获取公示牌信息
  getGspInfo: (id) => { return axios.get(`${iffApi}/xfwb/wbjh/gsp/${id}`); },

  // 导出公示牌Word文档
  exportGspWord: (id) => { return axios.get(`${iffApi}/xfwb/wbjh/exportGsp/${id}`, { responseType: 'blob' }); },

  // 下载维保报告PDF
  downloadWbbgPdf: (id) => { return axios.get(`${iffApi}/noauth/common/wbbg/${id}`, { responseType: 'blob' }); }

};
